document.addEventListener('DOMContentLoaded', function() {
  // Find all product gallery navigation buttons
  const galleryNavButtons = document.querySelectorAll('.product-gallery-nav');
  
  galleryNavButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Get the direction (prev or next)
      const direction = this.getAttribute('data-gallery-nav');
      
      // Find the closest product gallery
      const gallery = this.closest('.product-gallery-item').closest('.product-gallery');
      
      // Find the CSS slider if it exists
      const slider = gallery.querySelector('css-slider');
      
      if (slider) {
        // If slider exists, use its changeSlide method
        slider.changeSlide(direction);
      } else {
        // If no slider (e.g., in scroll mode), find the thumbnails and click the appropriate one
        const thumbnails = gallery.querySelectorAll('.product-gallery__thumbnails .thumbnail');
        if (thumbnails.length > 0) {
          // Find the currently active thumbnail
          const activeThumbnail = gallery.querySelector('.product-gallery__thumbnails .thumbnail.active');
          if (activeThumbnail) {
            const activeIndex = Array.from(thumbnails).indexOf(activeThumbnail);
            let newIndex;
            
            if (direction === 'prev') {
              newIndex = activeIndex > 0 ? activeIndex - 1 : thumbnails.length - 1;
            } else {
              newIndex = activeIndex < thumbnails.length - 1 ? activeIndex + 1 : 0;
            }
            
            // Click the new thumbnail
            thumbnails[newIndex].click();
          } else if (thumbnails.length > 0) {
            // If no active thumbnail, click the first one
            thumbnails[0].click();
          }
        }
      }
    });
  });
});
